var $80ee16b64fab9fb5$exports = {};
$80ee16b64fab9fb5$exports = {
  "removeButtonLabel": "Poista",
  "removeDescription": "Poista tunniste painamalla Poista-painiketta."
};
export { $80ee16b64fab9fb5$exports as default };